import React from "react";
import "../css/Projects.css";
import projects from "../data/projects.data";

function ProjectImage({ project }) {
  const [failed, setFailed] = React.useState(false);
  const hasImage = project.image && !failed;

  return (
    <div className={`projectImageFrame projectImageFrame-${project.tone || "neutral"}`}>
      {hasImage ? (
        <img
          src={project.image}
          alt={project.imageAlt || `${project.title} preview`}
          loading="lazy"
          decoding="async"
          style={project.imagePosition ? { objectPosition: project.imagePosition } : undefined}
          onError={() => setFailed(true)}
        />
      ) : (
        <div className="projectImageFallback">
          <span>{project.status || "Preview"}</span>
          <strong>{project.title}</strong>
          <small>Application screenshot</small>
        </div>
      )}
    </div>
  );
}

export default function Projects() {
  return (
    <section className="projects" id="projects">
      <header className="projectsHeader">
        <h2 className="projectsTitle">Selected projects</h2>
        <p className="projectsIntro">
          Independent products and experiments focused on real user problems. 
        </p>
      </header>

      <div className="projectsGrid">
        {projects.map((p, idx) => (
          <article className="projectCard" key={idx}>
            <ProjectImage project={p} />

            <div className="projectBody">
              <h3 className="projectName">{p.title}</h3>
              <div className="projectLinks">
                {p.links.demo && (
                  <a className="linkBtn" href={p.links.demo} target="_blank" rel="noopener noreferrer">
                    Visit
                  </a>
                )}
                {!p.links.demo ? (
                  <span className="linkBtn linkBtnMuted" aria-disabled="true">Visit</span>
                ) : null}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
